export const validateAndSubmit = {
    data() {
        disableOnSubmit : false
    },
    methods : {
        /**
         * General helper method for any forms in the site
         *
         * @param  {obj} event
         *
         * @return {void}
         */
        validateAndSubmit (scope) {
            this.disableOnSubmit = true;
            let _self = this;


            this.$validator.validateAll(scope).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    let form = document.getElementById(scope);
                    form.submit();
                }

                if (!result) {
                    _self.disableOnSubmit = false;
                }
            });
            
        },
    }
}